<template>
  <v-container>
    <v-row justify="space-between" class="my-2" no-gutters>
      <v-btn exact text :to="{ name: 'SuppliersIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
      <v-btn
        icon
        text
        v-if="supplier && id"
        v-show="!supplier.is_deleted"
        @click="deleteSupplier"
      >
        <v-hover v-slot:default="{ hover }">
          <v-icon :color="hover ? 'error' : ''">fa-trash</v-icon>
        </v-hover>
      </v-btn>
      <v-btn
        icon
        text
        v-if="supplier && id"
        v-show="supplier.is_deleted"
        @click="restoreSupplier"
      >
        <v-hover v-slot:default="{ hover }">
          <v-icon :color="hover ? 'success' : ''">fa-trash-restore</v-icon>
        </v-hover>
      </v-btn>
    </v-row>
    <section v-if="supplier && supplierData">
      <v-row align="center" class="mb-2">
        <v-col cols="12">
          <SuppliersStoreTag
            v-bind.sync="supplierData"
            :valid.sync="tagValid"
          ></SuppliersStoreTag>
        </v-col>
      </v-row>
      <v-tabs
        v-model="tabs"
        show-arrows
        background-color="transparent"
        slider-color="primary"
      >
        <v-tab>Fournisseur</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <SuppliersFields
                v-bind.sync="supplier"
                :valid.sync="valid"
              ></SuppliersFields>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab>Contact</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text>
              <SuppliersStoreFields
                v-bind.sync="supplierData"
                :valid.sync="dataValid"
              ></SuppliersStoreFields>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-row align="center" justify="end" class="mt-3" no-gutters>
        <v-btn
          color="primary"
          :disabled="!valid"
          :block="$vuetify.breakpoint.xsOnly"
          :large="$vuetify.breakpoint.smAndDown"
          @click="saveSupplier"
        >
          <v-icon small left>fa-save</v-icon>Enregistrer
        </v-btn>
      </v-row>
    </section>
    <div v-else>
      <v-card height="40rem">
        <v-overlay absolute>
          <v-row align="center" justify="center" no-gutters>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-overlay>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import {
  SuppliersFields,
  SuppliersStoreFields,
  SuppliersStoreTag
} from "../components";
export default {
  name: "SuppliersEditor",
  components: {
    SuppliersFields,
    SuppliersStoreFields,
    SuppliersStoreTag
  },
  props: {
    id: {
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters(["getOrganisationId", "getStoreId"])
  },
  data() {
    return {
      tabs: 0,
      loading: false,
      supplier: undefined,
      supplierData: undefined,
      valid: false,
      dataValid: false,
      tagValid: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.getData();
    });
  },
  async beforeRouteUpdate() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.loading = true;

        if (this.id) {
          this.supplier = await api.retrieveSupplier(this.id);
          if (this.supplier.data) {
            this.supplierData = this.supplier.data;
          } else {
            this.supplierData = {
              fk_supplier: this.id,
              store: this.getStoreId,
              contact_phone: "",
              contact_poste: "",
              contact_name: "",
              contact_email: "",
              supplier_tag: "",
              comments: ""
            };
          }
        } else {
          this.supplier = {
            organisation: this.getOrganisationId,
            name_fournisseur: "",
            country: "Canada",
            road: "",
            city: "",
            postal_code: "",
            courriel: "",
            telephone: "",
            poste: "",
            comments: "",
            is_deleted: false
          };
          this.supplierData = {
            store: this.getStoreId,
            contact_phone: "",
            contact_poste: "",
            contact_name: "",
            contact_email: "",
            supplier_tag: "",
            comments: ""
          };
        }
      } finally {
        this.loading = false;
      }
    },
    async saveSupplier() {
      try {
        this.$store.dispatch("startLoadingOverlay");
        if (this.valid === true) {
          if (this.id) {
            const data = {
              ...this.supplier
            };
            data.data = this.supplierData;
            await api.putSupplier(this.id, data);
          } else {
            const data = {
              ...this.supplier
            };
            data.data = this.supplierData;
            await api.postSupplier(data);
          }
          this.$router.push({ name: "SuppliersIndex" });
        }
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    },
    async deleteSupplier() {
      const confirm = await this.$dialog.warning({
        title: "Supprimer",
        text: "Êtes-vous certain de vouloir supprimer ce fournisseur?",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      if (confirm === true) {
        try {
          this.$store.dispatch("startLoadingOverlay");
          this.supplier.is_deleted = true;
          await api.putSupplier(this.id, this.supplier);
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    async restoreSupplier() {
      const confirm = await this.$dialog.warning({
        title: "Restauration",
        text: "Êtes-vous certain de vouloir restaurer ce fournisseur?",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      if (confirm === true) {
        try {
          this.$store.dispatch("startLoadingOverlay");
          this.supplier.is_deleted = false;
          await api.putSupplier(this.id, this.supplier);
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
